// extracted by mini-css-extract-plugin
export var actions = "_49-0";
export var actionsContainer = "_49-6";
export var border = "_49-1";
export var childFullHeight = "_49-d";
export var collapse = "_49-2";
export var content = "_49-8";
export var contentChild = "_49-c";
export var fullscreen = "_49-a";
export var headerContainer = "_49-3";
export var headerRow = "_49-5";
export var hidePadding = "_49-9";
export var noScrollX = "_49-e";
export var noScrollY = "_49-f";
export var optOutTopPadding = "_49-b";
export var pagePadding = "_49-7";
export var profile = "_49-g";
export var profileContainer = "_49-h";
export var profileImage = "_49-i";
export var profileMain = "_49-j";
export var profileSubtitle = "_49-l";
export var profileTitle = "_49-k";
export var tabsWrapper = "_49-4";
export var title = "_49-m";